import React, { useState } from "react";
import ssoManagementService from "../../../services/SSOManagementService";
import { ProviderSiteDTO } from "@beable/roster-backend-client-v1";
import ProviderSiteForm from "../Sites/ProviderSiteForm";
import FormModal, { ModalMessageSettings, getResultMessage } from "../../Common/FormModal";

interface AddProviderSiteProps {
  open: boolean;
  handleClose: any;
  selectedItem?: ProviderSiteDTO;
}

export default function AddProviderSiteModal(props: AddProviderSiteProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [messageSetting, setMessageSetting] = useState<ModalMessageSettings>();

  const submitForm = async (
    siteDto: ProviderSiteDTO,
    allEnvs: boolean,
    env: string
  ) => {
    setIsLoading(true);
    const { success, error } = await ssoManagementService.addNewProviderSite(
      siteDto,
      allEnvs,
      env
    );
    const message = getResultMessage(success ? true : undefined, success, error);
    setMessageSetting(message);
    setIsLoading(false);
  };

  const handleClose = () => {
    props.handleClose(messageSetting?.severity === "success");
    setMessageSetting(undefined);
  }

  return (
    <FormModal
      isOpen={props.open}
      title="Add new SSO site"
      description="Adds a new site for an SSO provider."
      isLoading={isLoading}
      handleClose={handleClose}
      message={messageSetting}
    >
      <ProviderSiteForm
        onSubmit={submitForm}
        handleClose={handleClose}
      />
    </FormModal>
  );
}
